import React, { useState, useEffect } from 'react';
import styles from "./StorageList.module.css";
import LineName from './LineName';
import { useTranslation } from 'react-i18next';
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";

function StorageList(props) {
    const { t } = useTranslation();
    const [lineList, setLineList] = useState([]);

    // 개별 상태 대신, 열려있는 저장소 번호를 담는 객체로 통합 관리
    // 초기값 false는 기존 visibleFirst~Fourth가 false인 점을 유지한 것입니다.
    const [openStates, setOpenStates] = useState({
        1: false,
        2: false,
        3: false,
        4: false
    });

    useEffect(() => {
        const reqOption = {
            method: "post",
            headers: {
                "content-type": "application/json"
            },
        };

        fetch("/api/getLineList", reqOption)
            .then((response) => response.json())
            .then(data => {
                setLineList(data);
            })
            .catch(err => console.error("Line List Fetch Error:", err));
    }, []);

    // 토글 핸들러: 기존 setVisibleX(!visibleX) 로직과 동일하게 작동
    const toggleStorage = (vesselNo) => {
        setOpenStates(prev => ({
            ...prev,
            [vesselNo]: !prev[vesselNo]
        }));
    };

    // 저장소 번호 배열 (필요시 5, 6... 추가가 용이함)
    const vesselNumbers = [1, 2, 3, 4];

    return (
        <div className={styles.storageListMain}>
            {vesselNumbers.map((no) => (
                <React.Fragment key={no}>
                    {/* 클릭 이벤트 및 클래스 적용 방식 기존과 동일 */}
                    <div onClick={() => toggleStorage(no)} className={styles.storageList_1}>
                        <span>
                            {/* openStates[no] 값에 따라 아이콘 스위칭 */}
                            {!openStates[no] && <img className={styles.storage_PlusImg} src={sideTriangleIcon} alt="plusImg" />}
                            {openStates[no] && <img className={styles.storage_MinusImg} src={downTriangleIcon} alt="minusImg" />}
                        </span>
                        <span className={styles.storageVesselTitle}>{t('초저온 저장소')}-{no}</span>
                    </div>

                    {/* 해당 저장소가 열려있을 때만 리스트 렌더링 */}
                    {openStates[no] && (
                        <>
                            {lineList
                                ?.filter(info => info.vesselNo === no)
                                .map((info, index) => (
                                    <LineName
                                        key={`${no}-${index}`}
                                        name={info.lineName}
                                        vessel={no}
                                        authLevel={props.authLevel}
                                    />
                                ))
                            }
                        </>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
}

export default StorageList;